import { render } from "./BuyLpModal.vue?vue&type=template&id=64492a3a&ts=true"
import script from "./BuyLpModal.vue?vue&type=script&lang=ts"
export * from "./BuyLpModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__